import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OrgState {
  selectedOrgId: number | null
  setSelectedOrgId: (id: number | null) => void
}

export const useOrgStore = create<OrgState>()(
  persist(
    (set) => ({
      selectedOrgId: null,
      setSelectedOrgId: (id) => set({ selectedOrgId: id }),
    }),
    { name: 'voorraad-kh-org' }
  )
)
